export const scrollToWithOffset = (id: string) => {
    const element = document.getElementById(id);
    const header = document.querySelector("header");
  
    if (element) {
      const headerHeight = header ? header.clientHeight : 0;
      const y =
        element.getBoundingClientRect().top + window.pageYOffset - headerHeight;
  
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };
  